/*
 * v17: Keep the header cart-count bubble in sync immediately after ANY cart mutation.
 * Needed because the UpCart cart-drawer app intercepts add-to-cart and bypasses Dawn's
 * native section re-render, so the header count only updated on a page reload.
 *
 * Strategy (app-agnostic): observe fetch AND XHR for /cart/(add|change|update|clear),
 * then re-render the `cart-icon-bubble` section via the Section Rendering API and swap it
 * into #cart-icon-bubble. Re-rendering the whole section also handles the empty -> non-empty
 * case (the .cart-count-bubble element only exists once the cart has items).
 */
(function () {
  if (window.__cartCountSyncInstalled) return;
  window.__cartCountSyncInstalled = true;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)/i;

  function cartUrl() {
    return (window.routes && window.routes.cart_url) ||
           (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + 'cart') ||
           '/cart';
  }

  var pending = false;
  function refreshCartIconBubble() {
    if (pending) return;
    pending = true;
    fetch(cartUrl() + '?section_id=cart-icon-bubble', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var target = document.getElementById('cart-icon-bubble');
        if (!target) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // The response may be wrapped in .shopify-section or returned raw.
        var source = doc.querySelector('.shopify-section') || doc.querySelector('#cart-icon-bubble') || doc.body;
        if (source) target.innerHTML = source.innerHTML;
      })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  function onCartMutation() {
    // small delay so the cart is committed server-side before we read the section
    setTimeout(refreshCartIconBubble, 60);
  }

  // 1) fetch (Dawn, UpCart, most modern apps)
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var input = arguments[0];
      var url = (input && input.url) ? input.url : String(input || '');
      var p = origFetch.apply(this, arguments);
      if (CART_MUTATION.test(url)) {
        p.then(function (res) { if (!res || res.ok) onCartMutation(); }).catch(function () {});
      }
      return p;
    };
  }

  // 2) XMLHttpRequest (older apps / jQuery.ajax)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__cartMutation = CART_MUTATION.test(String(url || '')); } catch (e) {}
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__cartMutation) {
      this.addEventListener('load', onCartMutation);
    }
    return origSend.apply(this, arguments);
  };

  // 3) Safety net: common custom events some cart apps dispatch
  ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, onCartMutation);
  });
})();
